export enum Offer {
  Sun = '1000',
  Screen = '1001'
}

export enum Gender {
  Male = 'male',
  Female = 'female'
}

export enum ButtonType {
  Next = 'next',
  Previous = 'previous',
  Default = 'default',
  Extra = 'extra'
}

export enum TileType {
  Default = 'default',
  Time = 'time',
  Smiley = 'smiley'
}

export enum GlassesType {
  GlassTypeSingle = 'single',
  GlassTypeSingleSun = 'singleSunglasses',
  GlassTypeMulti = 'multifocal',
  GlassTypeMultiSun = 'multifocalSunglasses',
  GlassTypeScreen = 'screenGlasses',
  GlassTypeSport = 'sportGlasses',
  GlassTypeLenses = 'lenses'
}

export enum GridType {
  Two = 'two',
  Six = 'six',
  Nine = 'nine',
  Twelve = 'twelve'
}

export enum BasketType {
  None = 0,
  Total = 1,
  Current = 2,
  Amount = 3
}

export enum SelectionType {
  Activity = 'activity',
  Gender = 'genders',
  Glasses = 'glasses',
  Screen = 'screen',
  Sport = 'sport',
  Transport = 'transport'
}

export enum SelectionTitleLists {
  Activity = 'activities',
  ActivityOverThirtySix = 'activitiesOverThirtySix',
  Gender = 'genders',
  Glasses = 'glasses',
  Screen = 'screens',
  Sport = 'sports',
  Transport = 'transport'
}

export enum ModuleOption {
  Thickness = 1,
  Dneye = 5,
  Colormatic = 10,
  Coating = 15,
  Monoplus = 16,
  Road = 17,
  Polarised = 18,
  Lifestyle = 19,
  Pro410 = 20,
  Sunthickness = 33,
  Suncolor = 40,
  Suncoating = 50,
  Color = 60,
  Ergo = 70,
  MDM = 80,
  Prisma = 90,
  Impressionist = 2
}

export enum ColorSets {
  Uni = 'bfe19663-632c-455c-8e9c-a3883aa917f0',
  Degrade = '840362c9-b2ed-44d0-bf2c-eac98c3b3925',
  Polarized = 'dfa8b79e-1473-48ee-b8b0-8f28a19e272c',
  SunContrast = '36616160-ab68-40dc-bf4f-55fb0887332e'
}

export enum InformationCodes {
  GlassTypeMulti = 'MS-MFRX',
  GlassTypeMultiSun = 'MS-MFSUN',
  GlassTypeSingle = 'MS-EVRX',
  GlassTypeSingleSun = 'MS-EVSUN',
  GlassTypeScreen = 'MS-BSB01',
  GlassTypeSport = 'MS-SG',
  GlassTypeReading = 'MS-RG',
  GlassTypeLenses = 'MS-LZ',

  GlassAdviceMulti = 'MS-AMFRX',
  GlassAdviceSingle = 'MS-AEVRX',

  ModuleDneye = 'MS-DNEYE',
  ModuleImpressionist = 'MS-IMPRESSIONIST',
  ModuleThickness = 'MS-THICKNESS',
  ModuleCoating = 'MS-COATING',
  ModuleLifestyle = 'MS-LIFESTYLE',
  ModuleColor = 'MS-COLOR',
  ModuleCoatingSun = 'MS-SUNCOATING',
  ModuleErgodesign = 'MS-ERGODESIGN',

  ModulePro410 = 'MS-PRO410',
  ModuleMDM = 'MS-MDM',
  ModuleColormatic = 'MS-COLORMATIC',
  ModuleSpherical = 'MS-SPHERICAL',
  ModuleStock = 'MS-STOCK',
  ModuleMonoplus = 'MS-MONOPLUS',
  ModulePrisma = 'MS-PRISMA'
}

export enum InformationTabCustomTypes {
  Thickness = 'GLASS_THICKNESS',
  AntiReflection = 'ANTI_REFLECTION',
  PhotoCromic = 'PHOTO_CROMIC'
}

export enum InformationTabTypes {
  Default = 'default',
  Image = 'image',
  Text = 'text',
  Video = 'video',
  Custom = 'custom'
}
